// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"document-popular"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M15.1425 21.5651C13.5 19.5001 14.5 17.5001 15.4999 16.5001L16.5 17.5001C17 17.0001 16.5 14.0001 20.2335 13.5C20.2335 14.9664 20.4759 15.6996 20.9607 16.4328C21.7727 17.8991 22.5 18.4635 22.5 20.0987C22.5 21.5651 21.0454 23.0314 19.5909 22.2983C18.9258 21.963 17.8092 22.0539 17.3244 22.2983C16.1607 22.8848 15.542 22.0673 15.1425 21.5651Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M15.1425 21.5651C13.5 19.5001 14.5 17.5001 15.4999 16.5001L16.5 17.5001C17 17.0001 16.5 14.0001 20.2335 13.5C20.2335 14.9664 20.4759 15.6996 20.9607 16.4328C21.7727 17.8991 22.5 18.4635 22.5 20.0987C22.5 21.5651 21.0454 23.0314 19.5909 22.2983C18.9258 21.963 17.8092 22.0539 17.3244 22.2983C16.1607 22.8848 15.542 22.0673 15.1425 21.5651Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20.5 9.5V2.5H3.5V21.5H11M8 8H16M8 12H12","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-document-popular')
export default class DocumentPopularIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'document-popular',
    }
  }
}
